export const IconBasicSubs = (props) => {
  return (
    <svg
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="50" height="50" rx="10" fill="#F2F4F8" />
      <path
        d="M35.7344 9.61209C36.0029 8.88657 37.029 8.88657 37.2975 9.61209L37.7926 10.9501C37.877 11.1782 38.0568 11.358 38.2849 11.4424L39.6229 11.9375C40.3484 12.206 40.3484 13.2322 39.6229 13.5006L38.2849 13.9957C38.0568 14.0801 37.877 14.26 37.7926 14.4881L37.2975 15.8261C37.029 16.5516 36.0029 16.5516 35.7344 15.8261L35.2393 14.4881C35.1549 14.26 34.9751 14.0801 34.747 13.9957L33.409 13.5006C32.6834 13.2322 32.6834 12.206 33.409 11.9375L34.747 11.4424C34.9751 11.358 35.1549 11.1782 35.2393 10.9501L35.7344 9.61209Z"
        fill="#302571"
      />
      <path
        d="M11.0299 31.8777C11.2983 31.1522 12.3245 31.1522 12.593 31.8777L12.6182 31.9459C12.7026 32.174 12.8824 32.3538 13.1105 32.4382L13.1787 32.4635C13.9042 32.7319 13.9042 33.7581 13.1787 34.0265L13.1105 34.0518C12.8824 34.1362 12.7026 34.316 12.6182 34.5441L12.593 34.6123C12.3245 35.3378 11.2983 35.3378 11.0299 34.6123L11.0046 34.5441C10.9202 34.316 10.7404 34.1362 10.5123 34.0518L10.4441 34.0265C9.7186 33.7581 9.7186 32.7319 10.4441 32.4635L10.5123 32.4382C10.7404 32.3538 10.9202 32.174 11.0046 31.9459L11.0299 31.8777Z"
        fill="#302571"
      />
      <path
        d="M13.6855 24.0754L26.7792 12.4101C27.8536 11.4529 29.5546 12.2155 29.5546 13.6545V20.4487C29.5546 21.3691 30.3008 22.1153 31.2212 22.1153H33.6365C35.1065 22.1153 35.8567 23.88 34.8366 24.9385L21.9832 38.277C20.9425 39.3569 19.1164 38.6202 19.1164 37.1205V28.6531C19.1164 27.7327 18.3702 26.9865 17.4498 26.9865H14.7942C13.2626 26.9865 12.5419 25.0942 13.6855 24.0754Z"
        fill="#302571"
        stroke="#302571"
        stroke-width="1.66667"
      />
    </svg>
  );
};
